import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'commaToPoint',
    standalone: false
})
export class CommaToPointPipe implements PipeTransform {

  transform(value: string): string {
    if (!!value && value.length > 0) {
      value = value.replace(",", ".");
      value = value.replace(" ", "");
    }
    return value;
  }

}

